// Aktuell gewählter Besitzbereich (privat oder eine Gruppe). Die Wahl wird
// lokal gemerkt, damit sie auch offline erhalten bleibt.
const STORAGE_KEY = 'shoppinglist.scope.v1';

let scope: string = localStorage.getItem(STORAGE_KEY) ?? '';
const listeners = new Set<() => void>();

export const scopeStore = {
  get(): string {
    return scope;
  },
  set(next: string): void {
    scope = next;
    localStorage.setItem(STORAGE_KEY, next);
    for (const l of listeners) l();
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function defaultScopeForUser(userId: string): string {
  return `user:${userId}`;
}
